waitForElement('.cart-drawer')
  .then((cartElement) => {
    // Create a Mutation Observer to watch for changes in the cart.
    const cartObserver = new MutationObserver(handleCartMutation)
  
    // Define the options for the Mutation Observer.
    const observerOptions = {
      attributes: true, // Watch for changes to the attributes of the cart.
      attributeFilter: ['class'], // Only watch for changes to the "class" attribute.
    }
  
    // Start observing the cart element.
    cartObserver.observe(cartElement, observerOptions)
  })

const req = /(\d{1,})(\d{2})$/ // Regular expression to extract a number with a dollar sign ($) and optional '+' sign 

function waitForElement(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector))
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector))
          observer.disconnect()
        }
      })

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      })
    })
  }

//get cart
function getCart() {
  return new Promise((resolve, reject) => {
    fetch(`/cart.js`, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET'
    }).then(res => res.json()).then(data => {
      resolve(data)
    }).catch((error) => {
      console.error('Error:', error)
    })
  })
}

function spendDiscount(total) {
    let discount = ``
    if (total >= 0 && total <= 99.00) {
      discount = `<p>Spend <b>$99</b> and get a <b>10% discount</b></p>`
    } else if (total > 99.00 && total <= 149.00) {
      discount = `<p>Spend <b>$149</b> and get a <b>15% discount</b></p>`
    } else if (total > 149.00) {
      discount = `<p>Spend <b>$199</b> and get a <b>20% discount</b></p>`
    }

    let discountHTML = `
  <div class="discount d-flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
          <circle cx="14" cy="14.25" r="14" fill="#E8F8FE"/>
          <path d="M8.53864 8H13.3148C13.8598 8 14.3726 8.22387 14.7573 8.60765L20.399 14.2364C21.2003 15.036 21.2003 16.3472 20.399 17.1468L16.1357 21.4003C15.3343 22.1999 14.02 22.1999 13.2187 21.4003L7.57699 15.7716C7.19233 15.3878 7 14.8761 7 14.3324V9.53512C7 8.7036 7.67315 8 8.53864 8ZM10.5902 12.6054C11.1351 12.6054 11.6159 12.1576 11.6159 11.582C11.6159 11.0383 11.1351 10.5585 10.5902 10.5585C10.0132 10.5585 9.5644 11.0383 9.5644 11.582C9.5644 12.1576 10.0132 12.6054 10.5902 12.6054Z" fill="#023F88"/>
      </svg>  
      <div>
        ${discount}
      </div>  
  </div>`

    if (!document.querySelector('.cart-drawer .discount')) {
      waitForElement('.cart-drawer__items').then(el => el.insertAdjacentHTML('afterend', discountHTML))
    } else {
      document.querySelector('.cart-drawer .discount div').innerHTML = discount
    }

    if (document.querySelector('.main-content .discount')) {
      document.querySelector('.main-content .discount div').innerHTML = discount
    }
}

// Function to calculate the total price based on the items in the cart.
function calculateTotalPriceItems(items) {
  let total = 0
  items.forEach((item) => {
    const price = +(item['price'].toString().replace(req, "$1.$2"))
    const quantity = item['quantity']
    total += price * quantity
  })
  return total
}

// Function to generate the subtotal block HTML.
function subtotalBlock(items, totalPrice) {
  return /*html */ `
    <div class="subtotal_block">
      <div class="product_title_wrapp">
        <ul class="product_title_list">
          ${items.map((item) => `
            <li>
              <p class="product_title_txt">${item.title}</p>
              <p class="product_title_price">$${(item.price * item.quantity).toString().replace(req, "$1.$2")}</p>
            </li>
          `).join('')}
        </ul>
      </div>
      <div class="subtotal_txt_wrapp">
        <p>Subtotal</p>
        <p class="subtotal_price">$${totalPrice.toFixed(2)}</p>
      </div>
    </div>`
}

// Function to handle the observed mutations on the cart element.
function handleCartMutation(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const targetElement = mutation.target
      if (targetElement.classList.contains('is-open') && !targetElement.classList.contains('is-loading')) {
        getCart().then(data => {
          if (data.items.length > 0) {
            const items = data.items
            let total = +(data['total_price'].toString().replace(req, "$1.$2"))

            total = calculateTotalPriceItems(items)

            // Check if the subtotal block does not exist and insert it.
            if (document.querySelector(".cart-drawer__items") && !document.querySelector(".subtotal-wrapper")) {
              const subtotalHTML = subtotalBlock(items, total)
              document.querySelector(".cart-drawer__items").insertAdjacentHTML("afterend",
                `<div class="subtotal-wrapper">${subtotalHTML}</div>`)
            } else {
              document.querySelector(".subtotal-wrapper").innerHTML = subtotalBlock(items, total)
            }

            spendDiscount(total)

          } else if (document.querySelector('.cart-drawer .discount') && document.querySelector('.subtotal_block')) {
            document.querySelector('.cart-drawer .discount').remove()
            document.querySelector('.cart-drawer .subtotal_block').remove()
          }
        })
        
      }
    }
  }
}